// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"51":"wp-content/themes/bel-architecten-theme/public/styles/login","135":"wp-content/themes/bel-architecten-theme/public/styles/editor","485":"wp-content/themes/bel-architecten-theme/public/styles/app","521":"wp-content/themes/bel-architecten-theme/public/styles/admin"}[chunkId] + ".css";
};